/*!
 *
 * components.js
 *
 */

'use strict';

require('jquery');
require('jquery.easing');
require('jquery.transit');
require('jquery.mousewheel');
require('jquery-mobile-events');
require('origin');
require('slick-carousel');
require('phone-check');
require('nav-active');
//require('map')($);
require('fancybox')($);

var linker = require('linker');
var slideScroll = require('slide-scroll');
require('menu');
require('fade-contents');
require('fit-image');
require('input-instagram');
var topMain = require('top-main');
var expandMenu = require('expand-menu');
var switchFontSize = require('switch-fontsize');

$(function(){
	linker.init();
	$.phoneCheck();
	slideScroll({
		easing : 'easeOutExpo',
		speed : 700,
		not: '#menu a, .st-Header_Sub_Size_Link, .st-Header_Sub_Search_Link,.recruit-Header_Sub_Size_Link, .recruit-Header_Sub_Search_Link'
	});

	origin.$window.on("scroll", function(){
		if( !origin.VPisMobile ){
			$(".st-Header, .recruit-Header").css("left", -$(window).scrollLeft());
		};
	});

	$('#menu a').menu();
	$('.main-Fit').fitImages();
	$('.main-Fit-retina').fitImages({
		isHalf: true
	});

	$('.sw-Fade,.sw-MainFade,.sw-ShiftFade').fadeContents();

	$('.main-Carousel').on('init', function(){
		origin.$window.trigger('fadeInit');
	}).slick({
		dots: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
	origin.$window.trigger('scroll');

	$('#global').navActive({
		not: '.st-Global_List_Item:first-child a, .recruit-Global_List_Item:first-child a'
	});
	$('.st-Pagelink_List').navActive({abs: true});

	$('.gailler').fancybox();

	switchFontSize({
		cookieName: 'ksk-font-size',
		btn: '.st-Header_Sub_Size_List_Btn'
	});
	switchFontSize({
		cookieName: 'ksk-font-size',
		btn: '.recruit-Header_Sub_Size_List_Btn'
	});

	expandMenu('.st-Header_Sub_Size, .st-Header_Sub_Search, .recruit-Header_Sub_Size, .recruit-Header_Sub_Search');

	topMain();

	  var $win = $(window),
      $header = $('header'),
      animationClass = 'is-animation';

	  $win.on('load scroll', function() {
	    var value = $(this).scrollTop();
	    if ( value > 100 ) {
	      $header.addClass(animationClass);
	    } else {
	      $header.removeClass(animationClass);
	    }
	  });

	$('#InstagramInput').inputInstagram();
	$('#InstagramInputRecruit').inputInstagram({
		count: 4,
		cl: 'recruit-Instagram_Item'
	});
});


//////////////////
// WEBPACK FOOTER
// ./dev/js/components.js
// module id = 0
// module chunks = 0